import new_axios_instance from '../../axios_instance';

import {notifsActions} from '../index';
import {createMessageRequestException, printOnlyInDevelopment} from "../../fanctionUtility";

import * as types from '../actionsTypes/tipiAttivitaActionsType'
import {hideLoadingOverlay, showLoadingOverlay} from "./loadingOverlayActions";


//Lista Tipi Corso per Tipo Attivita
/*export const getAttivitaByTipoCorsoStart = (tipoCorso) => async dispatch => {
    dispatch(loadingOverlayActions.showLoadingOverlay());
    dispatch(getAttivitaByTipoCorsoStartAction());
    await new_axios_instance(`/v1/tipoattivita/ricerca/tipoCorso/${tipoCorso}`)
        .then(response => {
            dispatch(getAttivitaByTipoCorsoSuccess(response.data));
            dispatch(loadingOverlayActions.hideLoadingOverlay());
        }).catch(error => {
            const message = createMessageRequestException(error);

            dispatch(getAttivitaByTipoCorsoFail(message));
            dispatch(notifsActions.notifError(message));
            dispatch(loadingOverlayActions.hideLoadingOverlay());
        });
};*/

export const getAttivitaByTipoCorsoStartAction = () => {
    return {
        type: types.GET_ATTIVITA_BY_TIPO_CORSO_START_ACTION
    }
};

// export for testing
export const getAttivitaByTipoCorsoSuccess = (attivita) => {
    return {
        type: types.GET_ATTIVITA_BY_TIPO_CORSO_SUCCESS,
        attivita
    }
};

// export for testing
export const getAttivitaByTipoCorsoFail = (error) => {
    return {
        type: types.GET_ATTIVITA_BY_TIPO_CORSO_SUCCESS,
        error
    }
};

export const initAttivitaByTipoCorso = () => {
    return {
        type: types.INIT_ATTIVITA_BY_TIPO_CORSO
    }
};


/******************************* Recupro tutti i tipi Attivita **********************/

export const getAllTipiAttivita = () => async dispatch => {
    await new_axios_instance.get(`/v1/tipoattivita/ricerca`)
        .then(response => {
            printOnlyInDevelopment('Tipi Corsi list ::', response.data);
            dispatch(getAllTipiAttivitaSuccess(response.data));
        }).catch(error => {
            /*if (error.response) {
                const e = error.response.data;
                if (typeof e === 'string' && (e.startsWith('it') || e.startsWith('java'))) {
                    dispatch(getAllTipiAttivitaFail(e));
                    dispatch(notifsActions.notifError(e.split(':').splice(1).join('</br>')));
                } else if (typeof e === 'object') {
                    dispatch(getAllTipiAttivitaFail(e));
                    const message = Object.keys(e).map(key => `${key.charAt(0).toUpperCase() + key.slice(1).toLowerCase()} : ${e[key]}`);
                    dispatch(notifsActions.notifError(message.join('</br>')));
                } else {
                    printOnlyInDevelopment(error);
                    dispatch(getAllTipiAttivitaFail('Impossibile concludere l\'operazione'));
                    dispatch(notifsActions.notifError('Impossibile concludere l\'operazione'));
                }
            } else {
                dispatch(getAllTipiAttivitaFail());
                dispatch(notifsActions.notifError(error.message));
            }*/

            const message = createMessageRequestException(error);

            dispatch(getAllTipiAttivitaFail(message));
            dispatch(notifsActions.notifError(message));

        });
};

const getAllTipiAttivitaSuccess = (tipiAttivita) => {
    return {
        type: types.GET_ALL_TIPI_ATTIVITA_SUCCESS,
        tipiAttivita: tipiAttivita
    }
};

const getAllTipiAttivitaFail = (error) => {
    return {
        type: types.GET_ALL_TIPI_ATTIVITA_FAIL,
        error: error
    }
};

/******************************* Recupro tutti i tipi Attivita **********************/
/******************************* Aggiorna Attivita **********************************/

export const aggiornaAttivita = (attivita) => async dispatch => {
    dispatch(initUpdateFields());
    dispatch(showLoadingOverlay());
    await new_axios_instance.put(`/v1/tipoattivita/aggiorna`, attivita)
        .then(response => {
            printOnlyInDevelopment('RESPONSE AGGIORNAMENTO ATTIVITA', response);
            dispatch(hideLoadingOverlay());
            dispatch(updateSuccess(response.data));
        })
        .catch(error => {
            const messageError = createMessageRequestException(error);
            dispatch(notifsActions.notifError(messageError));
            dispatch(hideLoadingOverlay());
        })
};

const updateSuccess = (attivitaUpdated) => {
    return {
        type: types.UPDATE_SUCCESS,
        attivitaUpdated: attivitaUpdated
    }
};

export const initUpdateFields = () => {
    return {
        type: types.INIT_UPDATE_FIELDS
    }
};

/******************************* Aggiorna Attivita **********************************/
/******************************* Inserisci Attivita **********************************/

export const inserisciAttivita = (newAttivita) => async dispatch => {
    dispatch(initUpdateFields());
    dispatch(showLoadingOverlay());
    await new_axios_instance.post(`/v1/tipoattivita/inserisci`, newAttivita)
        .then(response => {
            printOnlyInDevelopment('RESPONSE INSERIMENTO NUOVA ATTIVITA', response.data);
            dispatch(getAllTipiAttivita());
            dispatch(insertTipoAttivitaSuccess(response.data));
            dispatch(hideLoadingOverlay());
            dispatch(notifsActions.notifSuccess('Operazione conclusa con successo'));
        })
        .catch(error => {
            const messageError = createMessageRequestException(error);
            dispatch(notifsActions.notifError(messageError));
            dispatch(hideLoadingOverlay());
        })
};

const insertTipoAttivitaSuccess = (nuovaAttivita) => {
    return {
        type: types.INSERT_TIPO_ATTIVITA_SUCCESS,
        nuovaAttivita: nuovaAttivita
    }
};
/******************************* Inserisci Attivita **********************************/



